import { render, staticRenderFns } from "./MissionReferralCodeParts.vue?vue&type=template&id=40c19e9e&scoped=true"
import script from "./MissionReferralCodeParts.vue?vue&type=script&lang=ts"
export * from "./MissionReferralCodeParts.vue?vue&type=script&lang=ts"
import style0 from "./MissionReferralCodeParts.vue?vue&type=style&index=0&id=40c19e9e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c19e9e",
  null
  
)

export default component.exports